import { useTranslation } from 'react-i18next';

const useXmlPattern = () => {
  const { t } = useTranslation();

  return [
    {
      pattern: new RegExp(/^[a-zA-Z0-9-\\äÄéèçàÜüÏïù'@# ]*$/),
      message: t('login.xmlSpecialChar')
    }
  ];
};

export default useXmlPattern;
